export default __webpack_public_path__ + "static/media/Livefit.63bb26e6.svg";